import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import QuickActionPanel from '../../components/ui/QuickActionPanel';
import ChannelTabs from './components/ChannelTabs';
import CloudCallingPanel from './components/CloudCallingPanel';
import EmailCampaignPanel from './components/EmailCampaignPanel';
import SMSMessagingPanel from './components/SMSMessagingPanel';
import SocialMediaPanel from './components/SocialMediaPanel';
import CommunicationHistory from './components/CommunicationHistory';
import TemplateLibrary from './components/TemplateLibrary';
import AISmartDialerPanel from './components/AISmartDialerPanel';
import PageLayout from '../../components/ui/PageLayout';

const CommunicationHub = () => {
  const [activeChannel, setActiveChannel] = useState('calling');
  const [activeTab, setActiveTab] = useState('channels');

  const renderChannelContent = () => {
    switch (activeChannel) {
      case 'calling':
        return <CloudCallingPanel />;
      case 'ai-dialer':
        return <AISmartDialerPanel />;
      case 'email':
        return <EmailCampaignPanel />;
      case 'sms':
        return <SMSMessagingPanel />;
      case 'social':
        return <SocialMediaPanel />;
      default:
        return <CloudCallingPanel />;
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'channels':
        return (
          <div className="space-y-6">
            <ChannelTabs 
              activeChannel={activeChannel} 
              onChannelChange={setActiveChannel} 
            />
            {renderChannelContent()}
          </div>
        );
      case 'history':
        return <CommunicationHistory />;
      case 'templates':
        return <TemplateLibrary />;
      default:
        return (
          <div className="space-y-6">
            <ChannelTabs 
              activeChannel={activeChannel} 
              onChannelChange={setActiveChannel} 
            />
            {renderChannelContent()}
          </div>
        );
    }
  };

  return (
    <PageLayout>
      <Helmet>
        <title>Communication Hub - LeadGen Pro</title>
        <meta name="description" content="Multi-channel outreach hub for cloud calling, email campaigns, SMS messaging, and social media engagement" />
      </Helmet>

      {/* Page Header */}
      <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-foreground mb-2">Communication Hub</h1>
          <p className="text-muted-foreground">
            Manage all your communications across email, SMS, calls, and social media
          </p>
        </div>
        <div className="flex items-center space-x-3 mt-4 lg:mt-0">
          <QuickActionPanel />
        </div>
      </div>

      {/* Main Navigation Tabs */}
      <div className="mb-6">
        <div className="border-b border-border">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('channels')}
              className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                activeTab === 'channels' ?'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground'
              }`}
            >
              Communication Channels
            </button>
            <button
              onClick={() => setActiveTab('history')}
              className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                activeTab === 'history' ?'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground'
              }`}
            >
              Communication History
            </button>
            <button
              onClick={() => setActiveTab('templates')}
              className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                activeTab === 'templates' ?'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground'
              }`}
            >
              Template Library
            </button>
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {renderTabContent()}
      </div>
    </PageLayout>
  );
};

export default CommunicationHub;